import React, { useEffect, useRef, useState } from 'react'
import InvFormListItem from '../../invoice/InvFormListItem'
import { MwButton } from '../../ui';
import EditorJS from '@editorjs/editorjs';
import Header from '@editorjs/header'; 
import List from '@editorjs/list';
import MwTabViewBody from '../../ui/tab/MwTabViewBody';
import MwTabViewHead from '../../ui/tab/MwTabViewHead';
import MwTabView from './../../ui/tab/MwTabView';
import { useTranslation } from 'react-i18next';
import { useCurrent, useFetch } from '../../../hooks';
import MultipleFileUploader from '../../../hooks/MultipleFileUploader';

 

const InvFormBody = ({
    SETTING_SHOW_INVOICE_PRODUCT_DESCRIPTION,
    SETTING_INV_QTY_DAYS,
    SETTING_INV_UOM_SHOW,
    initalProductItem,
    reloadProductList,
    showModalProductHandle,
    productList,
    setProductList,
    formErrors,
    invNotes,
    setInvNotes,
    priceListItems ,
    setVat,
    invoiceSettings ,
    taxesList,
    setTaxesList,
    setAttachedFiles , // New prop for attachment files
    attachedFiles  // New prop for initial attachment files
}) => {
    const [tabActive,setTabActive] = useState("items");
    const [isInitialized, setIsInitialized] = useState(false);
     const { currentTenantId, currentCompanyId, currentBranchId } = useCurrent();
        const baseUrl = `${process.env.REACT_APP_INV_API_SALES_SERVER_BASE_URL}/taxes/${currentTenantId}/${currentCompanyId}/${currentBranchId}`;
        const { data: taxesData, loading: taxesLoading } = useFetch(baseUrl);
        const [t, i18n] = useTranslation('global');
        const handleSetInvNotes = typeof setInvNotes === 'function' ? setInvNotes : () => {};
        const getEditorData = (value) => {
            if (!value) return { blocks: [] };
            if (typeof value === 'object') return value;
            try {
                const parsed = JSON.parse(value);
                if (parsed && typeof parsed === 'object') return parsed;
            } catch {}
            return { blocks: [] };
        };
        const initialNotesData = getEditorData(invNotes);

    const ejInstanceNotes = useRef();

    const initEditorNotes = () => {
        const editor = new EditorJS({
            /**
             * Id of Element that should contain Editor instance
             */
            holder: 'notes-editorjs',
            // placeholder: 'من فضلك ادخل ملاحظاتك علي عرض السعر',
            data: initialNotesData?.blocks?.length ? initialNotesData : { blocks: [] },
            onReady:()=>{
                ejInstanceNotes.current = editor;
            },
            onChange:async()=>{ 
                const content = await editor.saver.save();
                handleSetInvNotes(JSON.stringify(content))
                console.log(content)
            },
            autofocus: true,
            tools: { 
                header: {
                    class: Header,
                    inlineToolbar: ['link'],
                  }, 
                list: {
                    class: List,
                    inlineToolbar: true,
                  }, 
                }, 
            i18n: {
                direction: i18n.dir(),
            },
            });
    }
    useEffect(() => {
        let timer;
        const cleanupEditors = () => {
            if (ejInstanceNotes.current) {
                ejInstanceNotes.current.destroy();
                ejInstanceNotes.current = null;
            }
        };
        if (tabActive === "notes") {
            cleanupEditors();
            timer = setTimeout(() => {
                initEditorNotes();
            }, 100);
        }
        return () => {
            if (timer) clearTimeout(timer);
        };
    }, [tabActive]);

    useEffect(() => {
        if (!isInitialized && productList.length === 0) {
            setProductList([...initalProductItem]);
            setIsInitialized(true);
        }
    }, [isInitialized, productList, initalProductItem]);

    const addSectionHandler = (e)=>{
        e.preventDefault()
        setProductList([...productList,{
            index: productList.length,
            productId:'section', 
            productName: '',
            productDesc: '',
            qty:0,
            qtyDays:0,
            price:'0',
            product_discount:0,
            product_net_total:0,
            product_net_total_with_vat:'0',
            product_vat: 0,
            total_price:0,
            unit_id:1,
        }]);
    }
    const addItemHandler = (e)=>{
        e.preventDefault()
        
        setProductList([...productList,{
            index: productList.length,
            productId:'', 
            productName: '',
            productDesc: '',
            qty:1,
            qtyDays:1,
            price:'0'
        }]);
    }
    const handleMoveRow = (dragIndex, hoverIndex) => {
        const draggedItem = {...productList[dragIndex]};
        const updatedList = [...productList];
        
         const originalDraggedState = {
            productId: draggedItem.productId,
            productName: draggedItem.productName,
            price: draggedItem.price,
            priceUnit: draggedItem.priceUnit,
            qty: draggedItem.qty,
            qtyDays: draggedItem.qtyDays,
         };
    
         updatedList.splice(dragIndex, 1);
        
         updatedList.splice(hoverIndex, 0, {
            ...draggedItem,
            ...originalDraggedState,
            index: hoverIndex
        });
    
         const finalList = updatedList.map((item, idx) => ({
            ...item,
            index: idx
        }));
    
        setProductList(finalList);
    };
    return (
        <>
         <MwTabView>
            <MwTabViewHead  setTabActive={setTabActive} tabActive={tabActive} tabTitleList={[
               { label:t("invoices.itemsTab"), value:"items"},
                { label:t("invoices.notesTab"), value:"notes"},
                { label:t("invoices.attachmentsTab") || "Attachments", value:"attachments"} // Added new tab for attachments
                ]} />
            
            <MwTabViewBody>
                
            <div id='inv-body' className={`max-h-[calc(100vh-275px)] min-h-[calc(100vh-400px)] overflow-y-auto     ${tabActive === 'items' ? 'block' : 'hidden'} ` }   >
            <div className='  '>
                    { productList.map((e,index)=>{
                        return <InvFormListItem
                                    key = {index}
                                    index = {index}
                                    moveRow={handleMoveRow}
                                    reloadProductList = {reloadProductList}
                                    showModalProductHandle = {showModalProductHandle}
                                    productList = {productList}
                                    setProductList = {setProductList}
                                    formErrors = {index ===0 && formErrors}
                                    SETTING_INV_QTY_DAYS = {SETTING_INV_QTY_DAYS}
                                    SETTING_INV_UOM_SHOW = {SETTING_INV_UOM_SHOW}
                                    SETTING_SHOW_INVOICE_PRODUCT_DESCRIPTION = {SETTING_SHOW_INVOICE_PRODUCT_DESCRIPTION}
                                    isEdit={true}
                                    priceListItems = {priceListItems}
                                    setVat={setVat}
                                    invoiceSettings={invoiceSettings}
                                    taxesData={taxesData} // تمرير بيانات الضرائب
                                    taxesLoading={taxesLoading} // تمرير حالة التحميل
                                    taxesList={taxesList}
                                    setTaxesList={setTaxesList}


                                    />
                        })
                    }
                </div>
                    <div className='  flex justify-end gap-1 m-3'>
                        <MwButton size='sm' actionType="button" type="secondary" onClick={addSectionHandler} >   {t("quotes.addItem")}</MwButton>
                        {/* <MwButton size='sm' actionType="button" type="secondary" onClick={ addItemHandler} > {t("quotes.addItem")}</MwButton> */}
                    </div>
                </div>
                <div id="notes-editorjs" className={`h-full p-4 bg-white rounded-lg ${i18n.dir() === 'rtl' ? 'text-right' : 'text-left'} ${tabActive === 'notes' ? 'block' : 'hidden'}`} >
                
                </div>
                 {/* New Attachments Tab */}
                 <div className={`p-4 bg-white rounded-lg ${tabActive === 'attachments' ? 'block' : 'hidden'}`}>
                    <div className="mb-4">
                        <h6 className="text-lg font-medium mb-2">{t('invoices.attachFiles') || "Attachment Files"}</h6>
                        <p className="text-sm text-gray-500 mb-4">
                            {/* {t('invoices.attachFilesDescription') || "Upload supporting documents for this invoice (images, PDFs)"} */}
                        </p>
                        <MultipleFileUploader 
                            setAttachedFiles ={setAttachedFiles } 
                            attachedFiles ={attachedFiles }
                        />
                    </div>
                </div>
            </MwTabViewBody>
        </MwTabView>
         </>
    )
}

export default InvFormBody
